import { ColumnsType, Text } from '@agro-club/agroclub-shared'
import { DASH } from 'modules/constants'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { TableTextLink } from 'views/ui/TableTextLink/TableTextLink'
import ElevatorRoutes from './routes'
import { generatePath } from 'react-router'
import { Elevator } from 'modules/domain/warehouses/types'
import { labelQuantity } from 'modules/utils/numbers/formatQuantity'
import { YesNoUnknown } from 'modules/domain/types'

const useColumns = (): ColumnsType<Elevator> => {
  const { t } = useTranslation('warehouses')

  const warehouseYNU = (value: YesNoUnknown | undefined) => {
    if (!value) return DASH
    return t(`warehouse:yesNoUnknown.${value}`)
  }

  return useMemo(
    () => [
      {
        title: t('common:name'),
        dataIndex: 'id',
        width: 300,
        render: (id, data) => (
          <TableTextLink id="elevator" to={generatePath(ElevatorRoutes.Details, { id })} key={id}>
            {data.title}
          </TableTextLink>
        ),
      },
      {
        title: t('railwayStation'),
        dataIndex: 'railway_station',
        width: 300,
        render: (railway_station: Elevator['railway_station']) =>
          railway_station ? `${railway_station.title} (${railway_station.station_code})` : null,
      },
      {
        title: t('address'),
        dataIndex: 'address',
        width: 400,
        render: (address: Elevator['address']) => (
          <div>
            <div>{address.address}</div>
            <Text color="secondary" typography="bodyMedium">
              {t('car_delivery_short')}: {warehouseYNU(address.car_delivery)}, {t('railway_delivery_short')}:{' '}
              {warehouseYNU(address.railway_delivery)},
            </Text>
          </div>
        ),
      },
      {
        title: labelQuantity(t('capacity')),
        width: 150,
        align: 'right',
        dataIndex: 'capacity',
      },
      {
        title: t('rail_car_capacity'),
        width: 150,
        align: 'right',
        dataIndex: 'rail_car_capacity',
      },
      {
        title: t('services'),
        width: 200,
        dataIndex: 'provided_services',
        render: (provided_services) => provided_services?.split(',').map((s) => <div key={s}>{s}</div>),
      },
    ],
    [t],
  )
}

export default useColumns
